import GalleryCardPropsType from "../../types/GalleryCardPropsType"
import ArrowRightRed from '../../assets/icons/arrow-right-red.svg';
import { useContext } from "react";
import PageContextType from "../../types/PageContextType";
import { LangContext, PageContext } from "../../App";

const GalleryCard = ({ 
    image,
    button,
    title,
    subtitle,
    list,
 } : GalleryCardPropsType) => {
    const { lang } = useContext(LangContext);
    const { handleChangePage } = useContext<PageContextType>(PageContext);

  return (
    <div className="gallery-card">
        {image ?
        <div className="card-header">
            <img src={image?.src} className="card-image" alt={image?.alt} />
        </div> :
        ""
        }
        <div className="card-body">
            <h2 className="card-title">{title}</h2>
            <p className="card-subtitle">{subtitle}</p>
            {
            list ?
            <ul className="card-list">
                {list?.map((item, index) => (
                    <li key={index} >{item}</li>
                ))}
            </ul> :
            ""
            }
            {button ?
            <button 
                type="button"
                className="card-button"
                title={`${!lang ? "Read more about" : "أقرأ المزيد عن "} ${title}`}
                aria-label={`${!lang ? "Read more about" : "أقرأ المزيد عن "} ${title}`}
                onClick={() => handleChangePage(button.path)}
            >
                <span>{button.text}</span>
                <img src={ArrowRightRed} className={lang === 0 ? "" : "rotate-rtl"} alt="" aria-hidden="true" />
            </button> :
            ""
            }
        </div>
    </div>
  )
}

export default GalleryCard